module.exports = __webpack_public_path__ + "static/scale-model-of-wild-west-adventures-in-plano-texas-edd16b4a1dfa0dc94df333e8b9104d37.png";